// @file Helper for post size.

const NON_STREAM_STANDARD_MAX_POST_SIZE = 256
const NON_STREAM_WIDE_MAX_POST_SIZE = 380

export { NON_STREAM_STANDARD_MAX_POST_SIZE, NON_STREAM_WIDE_MAX_POST_SIZE }
